import React from 'react';
import { useTheme } from '@fluentui/react';

interface IJsonResultProps {
    data: any;
}

export const JsonResult: React.FC<IJsonResultProps> = (
    props: IJsonResultProps
) => {
    const theme = useTheme();

    return (
        <div>
            {props.data && (
                <div
                    style={{
                        border: `1px solid ${theme.palette.neutralLight}`,
                        padding: '10px',
                        borderRadius: '5px',
                        marginTop: '10px',
                    }}
                >
                    <pre
                        style={{
                            whiteSpace: 'pre-wrap',
                            wordWrap: 'break-word',
                        }}
                    >
                        {JSON.stringify(props.data, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
};
